import { useGaugeChartAspectRatio } from './useGaugeChartAspectRatio.js';
import { useGaugeChartRangeMaxContext } from './useGaugeChartRangeMaxContext.js';
import { useGaugeChartRangeMinContext } from './useGaugeChartRangeMinContext.js';
import { useGaugeChartThresholdContext } from './useGaugeChartThresholdContext.js';
import { calculateThresholdLinePosition } from '../utils/calculate-threshold-line-position.js';

/**
 * Uses the config retrieved in the slots to create 2d lines to be used
 * as threshold indicators
 */
export const useThresholdConfigLines = () => {
  const thresholdConfig = useGaugeChartThresholdContext();
  const max = useGaugeChartRangeMaxContext();
  const min = useGaugeChartRangeMinContext();
  const { arcOuterRadius, arcInnerRadius } = useGaugeChartAspectRatio();

  return thresholdConfig.map(({ value }) =>
    calculateThresholdLinePosition(
      value,
      min,
      max,
      arcOuterRadius,
      arcInnerRadius,
    ),
  );
};
